export const money = (v) =>
  new Intl.NumberFormat("es-MX", { style: "currency", currency: "MXN" }).format(Number(v || 0));

export const fmtDate = (iso) => {
  if (!iso) return "";
  const m = /^(\d{4})-(\d{2})-(\d{2})$/.exec(String(iso));
  if (m) return `${m[3]}/${m[2]}/${m[1]}`;
  const [y, mo, d] = new Intl.DateTimeFormat("en-CA", { timeZone: "America/Merida" }).format(new Date(iso)).split("-");
  return `${d}/${mo}/${y}`;
};

export const fmtTime12 = (iso) => {
  if (!iso) return "";
  const d = new Date(iso);
  let h = d.getHours();
  const m = String(d.getMinutes()).padStart(2, "0");
  const ampm = h < 12 ? "am" : "pm";
  h = h % 12 || 12;
  return `${h}:${m} ${ampm}`;
};

export const hm12 = (hhmm) => {
  if (!hhmm) return "";
  const [h, m] = hhmm.split(":").map(Number);
  const ampm = h < 12 ? "am" : "pm";
  const h12 = h % 12 || 12;
  return `${h12}:${String(m).padStart(2, "0")} ${ampm}`;
};

export const fmtTimeMerida = (iso) => iso ? new Date(iso).toLocaleTimeString("es-MX", { timeZone: "America/Merida", hour: "2-digit", minute: "2-digit", hour12: true }) : "";

export const nowMeridaMin = () => {
  const s = new Date().toLocaleTimeString("en-GB", { timeZone: "America/Merida", hour: "2-digit", minute: "2-digit", hour12: false });
  const [h, m] = s.split(":").map(Number);
  return h * 60 + m;
};

export const todayISO = () => new Intl.DateTimeFormat("en-CA", { timeZone: "America/Merida" }).format(new Date());

export const validMxPhone = (p) => /^(\+?52)?\s?\d{10}$/.test((p || "").replace(/\s/g, ""));

export const WEEK_LABELS = { mon: "Lunes", tue: "Martes", wed: "Miércoles", thu: "Jueves", fri: "Viernes", sat: "Sábado", sun: "Domingo" };
export const WEEK_ORDER = ["mon", "tue", "wed", "thu", "fri", "sat", "sun"];

export const STATUS_LABELS = {
  pending: "Pendiente", confirmed: "Confirmada", attended: "Atendida",
  attending: "Atendiendo", cancelled: "Cancelada", no_show: "No asistió",
  waiting: "En espera",
};

// Estados claros para calendario y panel de citas
export const STATUS_META = {
  attended:  { label: "Servicio finalizado", color: "#22c55e" },
  attending: { label: "En servicio",         color: "#3b82f6" },
  waiting:   { label: "En fila",             color: "#a855f7" },
  confirmed: { label: "Cita programada",      color: "#d4af37" },
  pending:   { label: "Cita programada",      color: "#d4af37" },
  no_show:   { label: "No asistió",           color: "#ef4444" },
  cancelled: { label: "Cancelada",            color: "#ef4444" },
};
export const statusMeta = (s) => STATUS_META[s] || { label: s || "—", color: "#737373" };
export const STATUS_LEGEND = [
  { label: "Cita programada", color: "#d4af37" },
  { label: "En servicio", color: "#3b82f6" },
  { label: "Servicio finalizado", color: "#22c55e" },
  { label: "En fila", color: "#a855f7" },
];
